module.exports = __webpack_public_path__ + "static/scale-model-of-bronx-little-italy-in-yonkers-new-york-4ea934ece55ec8787f01611ae16f0148.png";